import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-body minheight d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { class: "text-center p-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "mt-2 d-block" }
const _hoisted_5 = {
  key: 1,
  class: "card-body"
}
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          }),
          _hoisted_3,
          _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.language.loading) + "...", 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.language.quote_nbr), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.language.customer), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.language.sub_total), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.language.tax), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.language.total), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.listOfSalesQuoteInfo.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfSalesQuoteInfo, (oTop) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: oTop.RecordPos
              }, [
                _createElementVNode("td", null, _toDisplayString(oTop.QuoteNbr), 1),
                _createElementVNode("td", null, _toDisplayString(oTop.CustomerName), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.appFxs.formatNumbers(oTop.SubTotal)), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.appFxs.formatNumbers(oTop.TaxValue)), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.appFxs.formatNumbers(oTop.GeneralTotal)), 1)
              ]))
            }), 128))
          ])
        ])
      ]))
}